<template>
    <noscript><img height="1" width="1" style="display:none" :src="url" /></noscript>
</template>

<script>
    import { bus } from '../../main'

    export default {
        name: 'Facebook',
        data() {
            return {
              loaded: false
            };
        },
        methods: {},
        components: {},
        computed: {
            id: function () {
                return process.env.VUE_APP_FACEBOOK;
            },
            url: function () {
                return 'https://www.facebook.com/tr?id=' + this.id + '&ev=PageView&noscript=1';
            },
            debug: function () {
                return process.env.VUE_APP_FACEBOOK_DEBUG !== 'false';
            }
        },
        mounted() {
            const self = this;

            !function (f, b, e, v, n, t, s) {
                if (f.fbq) {
                    return;
                }
                n = f.fbq = function () {
                    n.callMethod ?
                        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                };
                if (!f._fbq) {
                    f._fbq = n;
                }
                n.push = n;
                n.loaded = !0;
                n.version = '2.0';
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
                t.onload = function () {
                    self.$store.commit('setAnalyticsLoaded', 'facebook');
                    self.loaded = true;
                };

                setTimeout(function() {
                    if (!self.loaded) {
                        self.$store.commit('setAnalyticsLoaded', 'facebook');
                    }
                }, 1500);
            }(window, document, 'script',
                'https://connect.facebook.net/en_US/fbevents.js');
            window.fbq('init', self.id);
            window.fbq('track', 'PageView');

            bus.$on('laboratoryLanding.analytics', (data) => {
                if (!self.loaded) {
                    return;
                }

                let action;
                switch (data.action) {
                    case '20sec':
                        action = 'ViewContent';
                        break;
                    case 'loadAttachments':
                        action = 'InitiateCheckout';
                        break;
                }

                if (!action) {
                    return;
                }

                const params = {};
                if (self.$store.state.analyticsLandingParameter) {
                    params.service = self.$store.state.analyticsLandingParameter;
                }

                if (!self.debug) {
                    window.fbq('track', action, params);
                }

                console.debug('facebook send event:', action, params, self.debug);
            });
        },
    }
</script>
